import { render, staticRenderFns } from "./OrganismVamosPaLaCalleActividadDetalleGrid.vue?vue&type=template&id=6eb5a47b&scoped=true"
import script from "./OrganismVamosPaLaCalleActividadDetalleGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismVamosPaLaCalleActividadDetalleGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5a47b",
  null
  
)

export default component.exports